<template>
  <b-container>
    <!-- <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" /> -->
    <!-- {{model}} -->
    <!-- {{ permission }} -->
    <b-form-select
      v-if="permission == 'isFormViewer'"
      v-model="profileRelease.isFormViewer"
      id="perPageSelect"
      :options="booleanOpt"
      @change="save"
    ></b-form-select>
    <b-form-select
      v-if="permission == 'isFormEditor'"
      v-model="profileRelease.isFormEditor"
      id="perPageSelect"
      :options="booleanOpt"
      @change="save"
    ></b-form-select>
    <b-form-select
      v-if="permission == 'isFormFiller'"
      v-model="profileRelease.isFormFiller"
      id="perPageSelect"
      :options="booleanOpt"
      @change="save"
    ></b-form-select>
    <b-form-select
      v-if="permission == 'isPendingApproval'"
      v-model="profileRelease.isPendingApproval"
      :options="booleanOpt"
      @change="saveField"
    ></b-form-select>
    <b-form-select
      v-if="permission == 'isPendingViewer'"
      v-model="profileRelease.isPendingViewer"
      id="perPageSelect"
      :options="booleanOpt"
      @change="saveField"
    ></b-form-select>
    <b-form-select
      v-if="permission == 'hasAccess'"
      v-model="profileRelease.hasAccess"
      id="perPageSelect"
      :options="booleanOpt"
      @change="saveModule"
    ></b-form-select>
  </b-container>
</template>
<script>
export default {
  name: "SaveFormProfileRelease",
  props: {
    profileRelease: Object,
    profileId: String,
    permission: String,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      booleanOpt: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      model: {
        formId: 0,
        formName: "",
        isFormViewer: false,
        isFormEditor: false,
        isFormFiller: false,
        fieldId: 0,
        fieldName: "",
        isPendingApproval: false,
        isPendingViewer: false,
      },
    };
  },
  methods: {
    save() {
      this.$apiChecklist
        .post(
          "/profileRelease/SaveFormPermission/" + this.profileId,
          this.profileRelease
        )
        .then((response) => {
          this.$emit("show-alert-message");
          this.submitted = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    saveField() {
      this.$apiChecklist
        .post(
          "/profileRelease/SaveFieldPermission/" + this.profileId,
          this.profileRelease
        )
        .then((response) => {
          this.$emit("show-alert-message");
          this.submitted = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    saveModule() {
      this.$apiScheduler
        .post(
          "/profileRelease/SaveModulePermission/" + this.profileId,
          this.profileRelease
        )
        .then((response) => {
          this.$emit("show-alert-message");
          this.submitted = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
  },
};
</script>
